"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialState = exports.default = void 0;
var _StateHelper = _interopRequireDefault(require("../helpers/StateHelper.js"));
var _Report = _interopRequireDefault(require("../factories/Report.js"));
var _constants = require("../constants");
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}
var stateHelper = new _StateHelper.default(_Report.default);
var initialState = stateHelper.initialState;
exports.initialState = initialState;
var reducers = {};
reducers[_constants.REPORT_FETCHED] = stateHelper.set;
reducers[_constants.REPORTS_FETCHED] = stateHelper.set;
reducers[_constants.MEMBER_GROUP_REPORTS_FETCHED] = stateHelper.set;
reducers[_constants.CLASS_REPORTS_UNLOAD] = function classReportsUnload(state) {
  return state.filter(function (record) {
    return record.get('member_group_id') === null;
  });
};
var _default = exports.default = stateHelper.createReducer(reducers);